import * as print from './print.css'

export { print }
